module.exports = __webpack_public_path__ + "img/Syg_icon_sdfdssd.3d875e00.png";